import { Component, ElementRef, Input } from "@angular/core";
import { ThemeType } from "@ant-design/icons-angular";
import { UiTooltipPosition } from "@webapp/ui/tooltip/tooltip.models";

/**
 * This component extends the base Icon directive of NG-Zorro
 * Example usage : https://ng.ant.design/components/icon/en
 */

@Component({
  selector: "ui-icon",
  templateUrl: "./icon.component.html",
  styleUrls: ["icon.component.less"],
})
export class UiIconComponent {
  @Input()
  public uiClass: string;

  @Input()
  public legacyIconSrc: string;

  @Input()
  public uiSpin: boolean;

  @Input()
  public uiType: string;

  @Input()
  public uiTheme: ThemeType;

  @Input()
  public uiTwotoneColor: string;

  @Input()
  public uiIconfont: string;

  @Input()
  public uiRotate: number;

  @Input()
  public tooltipAppendToBody = false;

  @Input("uiTooltipTitle")
  public tooltipTitle?: string;

  @Input("uiTooltipPlacement")
  public tooltipPosition?: UiTooltipPosition = "top";

  @Input("uiTooltipOverlayClassName")
  public uiTooltipOverlayClassName?: string;

  @Input("uiTooltipOrigin")
  public tooltipOrigin?: ElementRef<HTMLElement>;

  get isLegacyIcon(): boolean {
    return this.uiClass && this.uiClass.indexOf("nc-icon") > -1;
  }
}
